import { serviceRoutes, get } from "./index";

export const consultarDistribuidores = async () =>
  await get(serviceRoutes.consultarDistribuidores, "");
